import React from "react"
import { Pressable } from "react-native"
import { ActivityIndicator } from "react-native-paper"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"

const ToolbarButton = ({
    icon,
    label,
    onPress,
    loading = false,
    color = theme.colors.greyAlt,
    style,
}) => (
    <Pressable
        onPress={onPress}
        disabled={loading}
        style={({ pressed }) => [
            style,
            { opacity: pressed ? 0.7 : 1 },
        ]}
    >
        {loading ? (
            <ActivityIndicator size={14} color={color} />
        ) : (
            <FontAwesome5 name={icon} size={14} color={color} solid />
        )}
        <TextM
            fontSize={12}
            fontWeight="Regular"
            color={color}
            style={{ marginTop: 2 }}
            wrap
        >
            {label}
        </TextM>
    </Pressable>
)

export default ToolbarButton
